import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class EquipmentTypeService {

  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {
  }

  Save(equipmentType) {
    return this.http.post(this.configurations.apiAddress + '/api/EquipmentType/save', equipmentType);
  }

  Search(searchText: string) {
    const myParams = new HttpParams().set('searchText', searchText == undefined ? '' : searchText);
    return this.http.get(this.configurations.apiAddress + '/api/EquipmentType/search', { params: myParams });
  }

  Delete(id: number) {
    return this.http.delete(this.configurations.apiAddress + '/api/EquipmentType/delete/' + id);
  }

  GetById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/EquipmentType/getById/' + id);
  }

  // names for pickers (user editor): any signed-in user
  GetAll() {
    return this.http.get(this.configurations.apiAddress + '/api/EquipmentType/getAll');
  }

  /** Equipment bulk sheet (Users Management): user name, then Equipment / Serial pairs, filled with today's equipment. */
  DownloadUsersTemplate() {
    return this.http.get(this.configurations.apiAddress + '/api/UserEquipment/template', { responseType: 'blob' });
  }

  UploadUsers(file: File) {
    const form = new FormData();
    form.append('file', file, file.name);
    return this.http.post(this.configurations.apiAddress + '/api/UserEquipment/upload', form);
  }
}
